import React, { useEffect, useState } from 'react';
import MainLayout from '../../Layout/main';

import Header from '../../Components/header-interna';

import { Helmet } from 'react-helmet-async';
import { PageTermsInterface } from '../../Services/types';
import { fetchData } from '../../../Api';

const Termos: React.FC<any> = ({initialData} : any) => {
    
    const [terms, setTerms] = useState<PageTermsInterface | null>(initialData?.termos);
    const [title, setTitle] = useState<string>("");
    
    useEffect(() => {
        if (initialData) return;
        const loadData = async () => {
            const response = await fetchData("termos");
            if(response){
                if (response.termos) setTerms(response.termos);
            }
        };
        
        loadData();
    }, []);

    useEffect(() => {
        if(terms)
            setTitle(terms.title);
        else
            setTitle("");
    }, [terms]);

    const breadcrumb = [{
        name: title,
        slug: 'termos-de-uso'
    }];
    
    return (
        <>
            <Helmet>
                <title>{title} - Uniexpo</title>
            </Helmet>

            <MainLayout>
                <Header title={title} breadcrumb={breadcrumb} />

                <section className="pt-8 pb-12">
                    <div className="max-w-screen-xl mx-auto px-4">
                        {terms && 
                            <div className="text-justify text-sm 2xl:text-base" dangerouslySetInnerHTML={{ __html: terms.content }} />
                        }
                    </div>
                </section>
            </ MainLayout>
        </>
    );
};

export default Termos;
